/* unplugin-vue-components disabled */import { render } from "./Teams.vue?vue&type=template&id=3771b8a4&ts=true"
import script from "./Teams.vue?vue&type=script&lang=ts"
export * from "./Teams.vue?vue&type=script&lang=ts"

import "./Teams.vue?vue&type=style&index=0&id=3771b8a4&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__